import { Component, Inject, Input, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'] // <-- corrected
})
export class LoaderComponent {
  @Input() messageText = '';
  @Input() messageHTML = '';

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<LoaderComponent>
  ) {
    // Initialize from dialog data if provided
    if (this.data) {
      this.messageText = this.data.messageText || '';
      this.messageHTML = this.data.messageHTML || '';
    }
  }
}
